import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import KPICard from './KPICard';

const SortableKPICard = ({ id, isReorderMode, ...kpiProps }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
  };

  return (
    <div ref={setNodeRef} style={style} className="relative group/sortable">
      {/* Drag Handle - Only shown in reorder mode */}
      {isReorderMode && (
        <div
          {...attributes}
          {...listeners}
          className="absolute -left-2 top-1/2 -translate-y-1/2 z-10 p-1.5 rounded-md bg-white border border-slate-200 shadow-sm cursor-grab active:cursor-grabbing hover:bg-slate-50 hover:border-blue-300 transition-all"
          data-testid={`drag-handle-${id}`}
        >
          <GripVertical className="w-4 h-4 text-slate-400" />
        </div>
      )}
      
      {/* KPI Card with reorder mode indicator */}
      <div className={isReorderMode ? 'ring-2 ring-blue-200 ring-offset-2 rounded-lg' : ''}>
        <KPICard {...kpiProps} />
      </div>
    </div>
  );
};

export default SortableKPICard;
